import React, { useContext } from 'react';
import { useNamespacedTranslation } from '../../../../../../../../../hooks/useNamespacedTranslation';
import { InventoryModalContext } from '../../InventoryModalContext';
import { Input } from '../../../../../../../../../components/form/Input';
import { i18Path } from '../../constants';

export const WarrantyInfoFormField: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const t = useNamespacedTranslation(i18Path);
  const { onChange: onFieldChange } = useContext(InventoryModalContext);
  return (
    <Input
      onChange={(value) => onFieldChange({ warrantyInfo: value })}
      label={t('form.fields.warrantyInfo')}
      placeholder={t('form.fields.warrantyInfoPlaceHolder')}
      name="warrantyInfo"
      size="md"
    />
  );
};
